import { useMemo } from 'react'

import { types } from '../../../../AwesomeBar'
import { label as careersLabel, useCareersSearchConfig } from './search-careers'
import { label as collegesLabel, useCollegesSearchConfig } from './search-colleges'
import { label as helpLabel, useHelpSearchConfig } from './search-help'
import { label as nlpLabel, useNlpSearchConfig } from './search-nlp'
import { label as pagesLabel, usePagesSearchConfig } from './search-pages'
import { label as postsLabel, usePostsSearchConfig } from './search-posts'

const DEFAULT_ALL_RESULTS_ORDER = [pagesLabel, postsLabel, collegesLabel, careersLabel, helpLabel, nlpLabel]

interface ISupportedSearchTypes {
  [key: string]: boolean
}

type TSupportedSearchConfigs = {
  searchConfigurations: types.ISearchConfiguration[]
  supportedSearchTypes: ISupportedSearchTypes
}

export const useSupportedSearchConfigs = () => {
  const colleges = useCollegesSearchConfig()
  const posts = usePostsSearchConfig()
  const careers = useCareersSearchConfig()
  const pages = usePagesSearchConfig()
  const nlp = useNlpSearchConfig()
  const help = useHelpSearchConfig()

  return useMemo(() => {
    const orderedConfigs = [colleges, posts, careers, pages, nlp, help].filter((c) => c !== null)
    return orderedConfigs.reduce(
      (acc: TSupportedSearchConfigs, config: types.ISearchConfiguration) => {
        acc.searchConfigurations.push(config)
        if (!config.hidden) {
          acc.supportedSearchTypes[config.label] = true
        }
        return acc
      },
      {
        searchConfigurations: [],
        supportedSearchTypes: {},
      } as TSupportedSearchConfigs,
    )
  }, [colleges, posts, careers, pages, nlp, help])
}

export const useAllResultsOrder = (supportedSearchTypes: ISupportedSearchTypes): string[] => {
  return useMemo(() => {
    return DEFAULT_ALL_RESULTS_ORDER.reduce((acc: string[], label: string) => {
      if (supportedSearchTypes[label]) acc.push(label)
      return acc
    }, [])
  }, [supportedSearchTypes])
}
